import { PlannerConfig, ConfigOptions, FeatureConfig } from '../@types';
import smastadCatalog from '@inter-ikea-storageone/range-smastad/data/catalog.json';
import smastadTemplate from '@inter-ikea-storageone/range-smastad/data/template.json';
import frames from './productGroups/frames';
import platform from 'rangeConfig/shared/utils/platform';
import { smastadComponentResolver } from '@inter-ikea-storageone/range-smastad';
import { plannerComponentResolver } from '@inter-ikea-storageone/range';
import legs from './productGroups/legs';
import fronts from './productGroups/fronts';
import { ToggleDoorsFeature as ToggleDoors } from 'rangeConfig/shared/features/ToggleHingeDoors';
import interiors from './productGroups/interiors';
import handles from './productGroups/handles';
import proppingCatalog from '@inter-ikea-storageone/range-smastad-propping/data/catalog.json';
import proppingTemplate from '@inter-ikea-storageone/range-smastad-propping/data/template.json';
import smastadInteriorSuggestionsCatalog from '@inter-ikea-storageone/range-smastad/data/interior-suggestions/catalog.json';
import smastadInteriorSuggestionsTemplate from '@inter-ikea-storageone/range-smastad/data/interior-suggestions/template.json';
import smastadFrontLayoutsCatalog from '@inter-ikea-storageone/range-smastad/data/front-layouts/catalog.json';
import smastadFrontLayoutsTemplate from '@inter-ikea-storageone/range-smastad/data/front-layouts/template.json';
import { HelpLinesFeature } from 'rangeConfig/shared/features/HelpLines/HelpLinesFeature';
import accessories from './productGroups/accessories';
import ageGroup from './productGroups/ageGroup';
import { getOptimizedModels } from '../shared/utils/optimizedModels';
import { RecommendHandles } from 'rangeConfig/shared/features/RecommendHandles/RecommendHandles';
import MeasureAction from 'components/SceneMenu/actions/MeasureAction';
import DoorsAction from 'components/SceneMenu/actions/DoorsAction';
import ProppingAction from 'components/SceneMenu/actions/ProppingAction';
import { HandlesDrillTemplate } from 'rangeConfig/shared/features/HandlesDrillTemplate/HandlesDrillTemplate';
import sprToVpcMap from '@inter-ikea-storageone/range-smastad/data/spr2vpc.json';
import { TopInfoFeature } from 'rangeConfig/shared/features/TopInfo/TopInfoFeature';
import { TopFrameWidgetInfoFeature } from 'rangeConfig/shared/features/TopFrameWidgetInfo/TopFrameWidgetInfoFeature';
import smastadLandingPageConfig from './smastadLandingPageConfig';
import furnitures from './productGroups/furnitures';
import { DistanceMeasurementFeature } from 'rangeConfig/shared/features/DistanceMeasurementFeature';
import { MultiWallSeeThroughFeature } from 'rangeConfig/shared/features/MultiWallSeeThroughFeature';

const defaultAssetsPath = '/assets/';
const assetsPath = import.meta.env.REACT_APP_ASSETS_PATH || defaultAssetsPath;
const screensaverPath = `${assetsPath}screensaver/screensaver_SMASTAD.mp4`;

const features = (): { mobile: FeatureConfig[]; desktop: FeatureConfig[] } => {
  return {
    mobile: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'ToggleDoors', feature: ToggleDoors },
      { id: 'RecommendHandles', feature: RecommendHandles },
      { id: 'HandlesDrillTemplate', feature: HandlesDrillTemplate },
      { id: 'TopInfo', feature: TopInfoFeature },
      { id: 'TopFrameWidgetInfo', feature: TopFrameWidgetInfoFeature }
    ],
    desktop: [
      { id: 'MultiwallSeeThroughFeature', feature: MultiWallSeeThroughFeature },
      { id: 'ToggleDoors', feature: ToggleDoors },
      { id: 'HelpLines', feature: HelpLinesFeature },
      { id: 'DistanceMeasurement', feature: DistanceMeasurementFeature },
      { id: 'RecommendHandles', feature: RecommendHandles },
      { id: 'HandlesDrillTemplate', feature: HandlesDrillTemplate },
      { id: 'TopInfo', feature: TopInfoFeature },
      { id: 'TopFrameWidgetInfo', feature: TopFrameWidgetInfoFeature }
    ]
  };
};

const productGroups: any = () => {
  const productGroups = {
    desktop: [frames, furnitures, fronts, handles, interiors, accessories, legs],
    mobile: [ageGroup, frames, furnitures, fronts, handles, interiors, legs]
  };

  return productGroups[platform].map(group => group());
};

const sceneActions = {
  desktop: [MeasureAction, DoorsAction, ProppingAction],
  mobile: [DoorsAction, MeasureAction]
};

const smastadPlannerConfig = (options?: ConfigOptions): PlannerConfig => {
  return {
    productCatalogs: [
      {
        name: 'smastad',
        catalog: getOptimizedModels(smastadCatalog),
        template: smastadTemplate,
        assetsPath
      },
      {
        name: 'smastad-interior-suggestions',
        catalog: smastadInteriorSuggestionsCatalog,
        template: smastadInteriorSuggestionsTemplate,
        assetsPath
      },
      {
        name: 'smastad-front-layouts',
        catalog: smastadFrontLayoutsCatalog,
        template: smastadFrontLayoutsTemplate,
        assetsPath
      },
      {
        name: 'propping',
        catalog: getOptimizedModels(proppingCatalog),
        template: proppingTemplate,
        assetsPath
      }
    ],
    sprToVpcMap,
    componentResolvers: [plannerComponentResolver, smastadComponentResolver],
    featureToggles: [],
    productGroups: productGroups(options),
    features: features()[platform],
    screensaverPath: screensaverPath,
    cameraBehavior: () => {},
    roomOptions: { wallColor: '#ecdec5' },
    sceneActions: sceneActions[platform],
    landingPageConfig: smastadLandingPageConfig
  };
};

export default smastadPlannerConfig;
